const fillTemplateWithTokens = (html = "", toks = []) => {
  const plain = stripHtml(html);
  let i = 0;
  // اضافه کردن نمایش جداگانه با |
  const joined = toks.map(String).join(",");
  return `(${joined})`;
};

// استخراج ترتیب کلیدهای {{k}} برای c_test
const extractCtestKeyOrder = (html = "") => {
  const rx = /\{\{(\w+)\}\}/g;
  const out = [];
  let m;
  while ((m = rx.exec(html))) out.push(String(m[1]));
  return out;
};

const stripHtml = (s = "") => String(s).replace(/<[^>]*>/g, "");

const isObj = (v) => v !== null && typeof v === "object";

export const getCorrectAnswer = (item) => {
  if (!item) return null;

  const kind = item.kind;
  const s = item.scoring || item.body?.scoring || {};

  if (kind === "passage_mcq") {
    const scoring = item.body.scoring || {};

    console.log(scoring);
    const correctSlot =
      typeof scoring.correctSlot === "number" &&
      !Number.isNaN(scoring.correctSlot)
        ? scoring.correctSlot
        : null;

    if (correctSlot == null) return "";

    const sentenceText =
      item.body?.sentence?.fa || item.body?.sentence?.en || ""; // خود جمله‌ی درست

    // این استرینگ برمی‌گرده (نه [object Object])
    if (sentenceText) {
      return `اسلات ${correctSlot}: ${sentenceText}`;
    }
    return `اسلات ${correctSlot}`;
  }

  if (kind === "audio_prompt") {
    return ``;
  }

  if (kind === "file_upload") {
    // برای این نوع سؤال، کلید ثابت وجود ندارد؛ تصحیح ۱۰۰٪ دستی است
    return null;
  }

  if (s.mode === "exact" && s.answerKey) return s.answerKey;
  if (Array.isArray(s.answerKeys) && s.answerKeys.length) return s.answerKeys;

  const slot = item.body?.scoring?.correctSlot;
  if (Number.isFinite(slot)) return { __type: "slot", value: slot };

  if (kind === "ordering_weighted") {
    const list = Array.isArray(item.body?.items) ? item.body.items : [];

    if (!list.length) return null;

    // فقط آیتم‌های غیر-distractor که targetIndex معتبر دارند
    const rankable = list
      .filter(
        (it) =>
          it?.isDistractor !== true &&
          Number.isFinite(it?.targetIndex) &&
          it.targetIndex > 0
      )
      .sort((a, b) => a.targetIndex - b.targetIndex);

    if (!rankable.length) return null;

    // تبدیل به لیبل قابل‌خواندن
    const parts = rankable.map((it, idx) => {
      const label = it?.label?.fa || it?.label?.en || String(idx + 1);
      return label;
    });

    // ✅ حالا به جای اندیس، خودِ جواب درست به صورت استرینگ برمی‌گرده
    // مثلا: "گزینه ۱ → گزینه ۲ → گزینه ۳"
    return parts.join(" \u2192 ");
  }

  if (kind === "select_sentence") {
    const body = item.body || {};
    const sentences = Array.isArray(body.sentences) ? body.sentences : [];
    const correctIdsRaw = Array.isArray(body.correctIds) ? body.correctIds : [];

    const correctIds = correctIdsRaw
      .map((id) => (id == null ? "" : String(id)))
      .filter(Boolean);

    if (!correctIds.length || !sentences.length) return "";

    const textMap = new Map(
      sentences.map((s) => [
        String(s.id),
        s?.text?.fa || s?.fa || s?.text?.en || s?.en || String(s.id),
      ])
    );

    const correctTexts = correctIds
      .map((id) => textMap.get(String(id)))
      .filter(Boolean);

    return correctTexts.join(" | ");
  }

  if (kind === "sentence_builder") {
    const body = item.body || {};
    const tokens = Array.isArray(body.tokens) ? body.tokens : [];
    const correctFirst =
      Array.isArray(body.correct) && body.correct.length ? body.correct[0] : [];

    if (!correctFirst.length || !tokens.length) return "";

    const labelMap = new Map(
      tokens.map((tk) => [
        String(tk.key),
        tk?.label?.fa || tk?.fa || tk?.label?.en || tk?.en || String(tk.key),
      ])
    );

    const words = correctFirst.map((k) => {
      const key = String(k);
      return labelMap.get(key) || key;
    });

    return words.join(" ");
  }

  if (kind === "drag_drop_item_target") {
    const body = item.body || {};
    const items = Array.isArray(body.items) ? body.items : [];
    const targets = Array.isArray(body.targets) ? body.targets : [];

    const targetLabelMap = new Map(
      targets.map((t, idx) => {
        const key = String(t.key || `T${idx + 1}`);
        const label = t?.label?.fa || t?.fa || t?.label?.en || t?.en || key;
        return [key, String(label)];
      })
    );

    if (!items.length) return "";

    const parts = items.map((it, idx) => {
      const itemKey = String(it.key || `I${idx + 1}`);
      const itemLabel =
        it?.label?.fa || it?.fa || it?.label?.en || it?.en || itemKey;

      const tKey = String(it.targetKey || "");
      const tLabel = targetLabelMap.get(tKey) || tKey || "";

      return `${String(itemLabel)} → ${String(tLabel)}`;
    });

    // فقط استرینگ خالص، بدون [object Object]
    return parts.join(" | ");
  }

  if (kind === "numeric") {
    const body = item.body || {};

    if (typeof body.exact === "number" && !Number.isNaN(body.exact)) {
      const exactStr = String(body.exact);

      if (
        typeof body.tolerance === "number" &&
        !Number.isNaN(body.tolerance) &&
        body.tolerance !== 0
      ) {
        // مثال: "10 ± 0.5"
        return `${exactStr} ± ${body.tolerance}`;
      }

      // مثال: "10"
      return exactStr;
    }

    if (
      body.range &&
      typeof body.range.min === "number" &&
      typeof body.range.max === "number" &&
      !Number.isNaN(body.range.min) &&
      !Number.isNaN(body.range.max)
    ) {
      // مثال: "5 – 10"
      return `${body.range.min} – ${body.range.max}`;
    }

    return "";
  }

  if (kind === "short_text") {
    const body = item.body || {};
    const acceptable = Array.isArray(body.acceptable)
      ? body.acceptable.map((s) => String(s))
      : [];

    // خروجی به صورت استرینگ خوانا
    if (!acceptable.length) return "";

    // مثلا: "تهران / Tehran / Tehran City"
    return acceptable.join(" / ");
  }

  if (kind === "word_bank") {
    const body = item.body || {};
    const blanks = Array.isArray(body.blanks) ? body.blanks : [];

    if (!blanks.length) return "";

    // خروجی به صورت استرینگ، مثلا:
    // "1: تهران / Tehran | 2: آسیا / Asia"
    const parts = blanks.map((b, idx) => {
      const blankKey = String(b.key || idx + 1);
      const answersRaw = Array.isArray(b.answers) ? b.answers : [];
      const labels = answersRaw
        .map((a) => a?.fa || a?.en || "")
        .filter(Boolean);

      if (!labels.length) return `${blankKey}: —`;
      return `${blankKey}: ${labels.join(" / ")}`;
    });

    return parts.join(" | ");
  }

  if (kind === "cloze_text" || kind === "cloze_paragraph") {
    const blanks = Array.isArray(item?.body?.blanks) ? item.body.blanks : [];
    if (!blanks.length) return null;

    const lines = blanks.map((b) => {
      const key = String(b?.key ?? "");
      const faArr = Array.isArray(b?.answers?.fa) ? b.answers.fa : [];
      const enArr = Array.isArray(b?.answers?.en) ? b.answers.en : [];
      const all = [...faArr, ...enArr]
        .map((s) => (s == null ? "" : String(s).trim()))
        .filter(Boolean);

      const uniq = [...new Set(all)];
      const joined = uniq.join(" / ") || "…";

      return `${key}: ${joined}`;
    });

    // ✅ در نهایت یک استرینگ قابل‌خواندن برمی‌گردد
    // مثلاً: "1: book / a book | 2: library | 3: student / pupil"
    return lines.join(" | ");
  }

  if (kind === "cloze_regex") {
    const regexes = Array.isArray(item?.body?.clozeRegexes)
      ? item.body.clozeRegexes
      : [];

    if (!regexes.length) return null;

    const parts = regexes.map((reg, idx) => {
      const label =
        reg?.placeholder?.fa || reg?.placeholder?.en || String(idx + 1);

      const raw = reg?.pattern || "";
      const alts = raw
        .split("/")
        .map((p) => p.trim())
        .filter(Boolean);

      const pretty = alts.length
        ? alts.map((p) => `/${p}/`).join("  OR  ")
        : "—";

      return `${label}: ${pretty}`;
    });

    return parts.join(" | ");
  }

  if (kind === "ordering") {
    const itemsArr = Array.isArray(item?.body?.items) ? item.body.items : [];
    if (!itemsArr.length) return null;

    const parts = itemsArr.map((it, idx) => {
      const label = it?.label?.fa || it?.label?.en || String(idx + 1);
      return label;
    });

    // خروجی: "آیتم۱ → آیتم۲ → آیتم۳"
    return parts.join(" \u2192 ");
  }

  if (kind === "image_matching") {
    const pairs = Array.isArray(item?.body?.pairs) ? item.body.pairs : [];
    if (!pairs.length) return null;

    const parts = pairs.map((p, idx) => {
      const imgLabel =
        p?.image?.alt?.fa ||
        p?.image?.alt?.en ||
        p?.label?.fa ||
        p?.label?.en ||
        p?.image?.url ||
        `#${idx + 1}`;

      const correctLabel = p?.label?.fa || p?.label?.en || `#${idx + 1}`;

      return `${imgLabel}: ${correctLabel}`;
    });

    // خروجی استرینگ آماده برای نمایش
    return parts.join(" | ");
  }

  if (kind === "drag_to_group") {
    const items = Array.isArray(item?.body?.items) ? item.body.items : [];
    const groups = Array.isArray(item?.body?.groups) ? item.body.groups : [];
    if (!items.length || !groups.length) return null;

    const groupLabelMap = new Map(
      groups.map((g) => [
        String(g.key),
        g?.label?.fa || g?.label?.en || String(g.key),
      ])
    );

    const parts = items.map((it) => {
      const itemKey = String(it.key);
      const itemLabel = it?.label?.fa || it?.label?.en || itemKey;
      const correctGroupKey = String(it.groupKey || "");
      const groupLabel =
        groupLabelMap.get(correctGroupKey) || correctGroupKey || "—";
      return `${itemLabel}: ${groupLabel}`;
    });

    // خروجی نهایی یک استرینگ آماده برای نمایش
    return parts.join(" | ");
  }

  if (kind === "matching") {
    const pairs = Array.isArray(item?.body?.pairs) ? item.body.pairs : [];
    if (!pairs.length) return null;

    const parts = pairs.map((p, idx) => {
      const left = p?.left?.fa || p?.left?.en || String(idx + 1);
      const right = p?.right?.fa || p?.right?.en || String(idx + 1);
      return `${left}: ${right}`;
    });

    // 👉 خروجی نهایی: یک استرینگ مثل:
    // "book: کتاب | pen: خودکار | table: میز"
    return parts.join(" | ");
  }

  // ✅ sentence_reconstruction: تمپلیت + یک یا چند پاسخ صحیح
  if (kind === "sentence_reconstruction") {
    const tmpl =
      item?.body?.text?.en || item?.body?.text?.fa || item?.body?.text || "";
    const accepted =
      Array.isArray(item?.body?.answers) &&
      item.body.answers.every(Array.isArray)
        ? item.body.answers
        : Array.isArray(item?.body?.answer)
        ? [item.body.answer]
        : [];
    if (!tmpl || !accepted.length) return null;

    // خروجی: جمله کامل‌شده با اولین پاسخ، و لیست باقی پاسخ‌های معادل
    const firstSentence = fillTemplateWithTokens(tmpl, accepted[0]);
    return {
      __type: "sent_rec",
      template: tmpl,
      variants: accepted,
      first: firstSentence,
    };
  }

  if (kind === "mcq_matrix") {
    const rows = Array.isArray(item?.body?.rows) ? item.body.rows : [];
    const cols = Array.isArray(item?.body?.cols) ? item.body.cols : [];
    const scoring = item.scoring || item.body?.scoring || {};
    const answerMap = scoring.answerMap || {};

    const colLabelMap = new Map(
      cols.map((c) => [
        String(c.key),
        c?.label?.fa || c?.label?.en || String(c.key),
      ])
    );

    const normalizeList = (raw) => {
      if (Array.isArray(raw)) {
        return raw.map((k) => String(k)).filter((k) => k.trim() !== "");
      }
      if (raw != null && raw !== "") {
        return [String(raw)];
      }
      return [];
    };

    const parts = rows.map((r) => {
      const rk = String(r.key);
      const rowLabel = r?.label?.fa || r?.label?.en || rk;
      const raw = answerMap[rk];
      const keys = normalizeList(raw);
      const labels = keys.map((k) => colLabelMap.get(String(k)) || String(k));
      return `${rowLabel}: ${labels.join(", ") || "…"}`;
    });

    const hasAny = parts.some((p) => p.includes(":") && !p.endsWith("…"));
    if (!hasAny) return null;

    // 👇 حالا خروجی مستقیم string است
    return parts.join(" | ");
  }

  // ✅ c_test: نمایش پاسخ هر کلید (fa یا en یا هرکدام که موجود است)
  if (kind === "c_test") {
    const textHtml =
      item?.body?.text?.en || item?.body?.text?.fa || item?.body?.text || "";
    const order = extractCtestKeyOrder(textHtml); // ["1","2",...]
    const blanks = Array.isArray(item?.body?.blanks) ? item.body.blanks : [];

    const list = order.map((k) => {
      const b = blanks.find((x) => String(x.key) === String(k)) || {};
      // پشتیبانی از هر دو اسکیمای قبلی/جدید
      let ans = "";
      if (b.answer) ans = String(b.answer).trim();
      else if (b.answers) {
        // اگر آرایه/چندزبانه بود، اولین مقدار غیرخالی را بردار
        const fa = Array.isArray(b.answers.fa)
          ? b.answers.fa[0]
          : b.answers?.fa;
        const en = Array.isArray(b.answers.en)
          ? b.answers.en[0]
          : b.answers?.en;
        ans = (fa || en || "").toString().trim();
      }
      return { key: k, ans };
    });

    return { __type: "ctest", list };
  }

  return null;
};
